<template>
  <b-container fluid>
    <header>
      <a href="https://www.advamed.org/" target="_blank"><img :src="'./assets/' + logo" alt="AdvaMed" class="logo"></a>
      <!-- <b-nav pills>
        <b-nav-item active>Active</b-nav-item>
        <b-nav-item>Link</b-nav-item>
        <b-nav-item>Another Link</b-nav-item>
      </b-nav> -->
    </header>
  </b-container>
</template>

<script>
export default {
  name: 'globalheader',
  props: ['logo']
}
</script>

<style lang="scss">
header {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 72px;
  padding: 55px;
  @media all and (max-width: $screen-md) {
    padding: 20px;
  }
  .logo {
    height: 72px;
    @media all and (max-width: $screen-md) {
      height: 42px;
    }
  }
}
</style>
